import { useEffect, useState, useRef } from "react";
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useNavigate, useParams } from "react-router-dom";
import "./ImageDisplay.css";
import LoadingGIF from "./assets/loading-yc.gif";
import LoadingGIF2 from "./assets/privacy-loading-spinner-yc.gif";
import LoadingGIF3 from "./assets/validation-loading-spinner-yc.gif";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { Button } from "@aws-amplify/ui-react";
import useMajorStore from "./utils/majorStore";
import { insertGalleryGenerationResult } from "./utils/supabase";
interface StoryData {
    en: string;
    ko: string;
}

const ImageDisplay = () => {
    const [randomImage, setRandomImage] = useState(LoadingGIF);

    const { uuid } = useParams<{ uuid: string }>();
    const [timeSpent, setTimeSpent] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const { setMajor } = useMajorStore();

    const imgRef = useRef<{ downloadUrl: string; uuid: string; story: StoryData }>({
        downloadUrl: "",
        uuid: "",
        story: { en: "", ko: "" }
    });

    function extractJsonContent(input: string): string {
        const startIndex = input.indexOf('{');
        const endIndex = input.lastIndexOf('}');
        if (startIndex !== -1 && endIndex !== -1) {
            return input.substring(startIndex, endIndex + 1);
        }
        return input;
    }

    function parseStoryData(jsonString: string): StoryData {
        try {
            const parsedData = JSON.parse(jsonString);
            return {
                en: parsedData.en || "",
                ko: parsedData.ko || ""
            };
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return { en: "", ko: "" };
        }
    }

    const updateImg = (data: { downloadUrl: string; uuid: string; story: string }) => {
        const jsonContent = extractJsonContent(data.story);
        const storyData = parseStoryData(jsonContent);
        imgRef.current = { downloadUrl: data.downloadUrl, uuid: data.uuid, story: storyData };
    };

    useEffect(() => {
        let fetchUrl = setInterval(() => {
            fetch(`${process.env.REACT_APP_API_ENDPOINT}apis/images/${uuid}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => {
                if(!response.ok){
                    throw new Error('Not Generated yet');
                }
                return response.json()
            })
            .then(data => {
                updateImg(data);
                clearInterval(fetchUrl);
            })
            .catch((err) => console.log("err", err))
        }, 3000);

        return () => clearInterval(fetchUrl)
    }, [uuid]);

    useEffect(() => {
        setMajor('');
        let timer = setInterval(() => {
            setTimeSpent((val) => val + 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const images = [LoadingGIF, LoadingGIF2, LoadingGIF3];
        const randomIndex = Math.floor(Math.random() * images.length);
        setRandomImage(images[randomIndex]);

        let checkImage = setInterval(() => {
            let image = new Image();
            image.src = imgRef.current.downloadUrl;
            image.onload = () => {
                setIsLoading(false);
                clearInterval(checkImage);
                insertGalleryGenerationResult(uuid);
            };
            image.onerror = () => {
                setIsLoading(true);
            };
        }, 5000);

        return () => clearInterval(checkImage);
    }, []);

    return (
        <div className="box-group">
            <TransitionGroup style={{ display: 'flex' }}>
                <CSSTransition
                    key={imgRef.current.uuid}
                    timeout={5000}
                    classNames={"page-transition"}
                    unmountOnExit
                    in={true}
                >
                    {isLoading ? <LoadingComponent image={randomImage} /> : <DisplayComponent url={imgRef.current.downloadUrl} story={imgRef.current.story} />}
                </CSSTransition>
            </TransitionGroup>
        </div>
    );
};

const LoadingComponent = (image) => {
    console.log(image);
    console.log(image.image);
    return (
        <div className="bg-box">
            <img src={image.image} className="bg-image loading-image" alt="loading" />
        </div>
    )
};

const DisplayComponent = ({ url, story }: { url: string, story: StoryData }) => {
    const navigate = useNavigate();
    return (
        <div className="bg-box">
            <div className="bg-textbox">
                <div className="bg-text">
                    <span>
                        <br /><br />
                        {story.ko}<br /><br />
                        {story.en}
                    </span>
                </div>
                <Button style={{ position: 'absolute', bottom: 20, left: 0 }} variation="primary" onClick={() => navigate('/photo/start')}>Home</Button>
                <QRCodeSVG level="L" value={url.split('?')[0]} style={{ position: 'absolute', bottom: 20, right: 0 }} />
            </div>
            <img src={url} className="bg-image" alt="gallery" />
        </div>
    )
};

export default ImageDisplay;